
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lr7iY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $47468ec2d2824c0c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $47468ec2d2824c0c$export$2e2bcd8739ae039 = {
    'fabric.editor.headingLink.ascSortingLabel': 'ascendente',
    'fabric.editor.headingLink.copied': "\xa1Copiado!",
    'fabric.editor.headingLink.copyAnchorLink': "Copiar enlace en el t\xedtulo",
    'fabric.editor.headingLink.copyAriaLabel': 'Copiar',
    'fabric.editor.headingLink.descSortingLabel': 'descendente',
    'fabric.editor.headingLink.failedToCopy': 'Copia fallida',
    'fabric.editor.headingLink.noneSortingLabel': 'ninguno',
    'fabric.editor.inlineComment.marker.end': 'final de comentario insertado',
    'fabric.editor.inlineComment.marker.start': 'inicio de comentario insertado'
};

});


//# sourceMappingURL=es.77a11605.js.map
